import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface VideoDescriptionProps {
  description: string;
  title: string;
}

const VideoDescription: React.FC<VideoDescriptionProps> = ({
  description,
  title
}) => {
  return (
    <Box
      position="absolute"
      bottom={4}
      left={4}
      right={{ base: "60px", md: "80px" }}
      zIndex={19}
      bg="linear-gradient(transparent, rgba(0, 0, 0, 0.7))"
      p={4}
      pt={8}
      pb={20}
      maxW={{ base: "calc(100vw - 80px)", md: "calc(100vw - 160px)" }}
    >
      <Text
        color="white"
        fontSize="sm"
        fontWeight="medium"
        lineHeight="1.4"
        noOfLines={3}
        mb={2}
      >
        {title}
      </Text>
      
      <Text
        color="white"
        fontSize="sm"
        opacity={0.9}
        lineHeight="1.4"
        noOfLines={4}
      >
        {description}
      </Text>
    </Box>
  );
};

export default VideoDescription;
